import { NO_RETURN_POLICY_TEXT } from '../../component/policyConstants';
import React, { useEffect, useState, useContext } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import { AiOutlinePullRequest, AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { BiEditAlt, BiTrash } from "react-icons/bi";
import Loader from '../../component/loader';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import AddCategory from './ProductComponent/addCategory';
import ProductInformation from './ProductComponent/productInformation';
import ProductPrice from './ProductComponent/productPrice';
import Filter from './ProductComponent/filter';
import { Modal, Button, Table } from 'react-bootstrap';
import OrderStatus from './orderStatus';
import axios from 'axios';
import Cookies from 'js-cookie';
import { decrpt } from '../../component/encryption';
import Pagination from "react-js-pagination";
import NotApprove from '../../component/notApprove';
import RegistrationStatus from "../../context/RegistrationStatus";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function ProductList() {
    const navigate = useNavigate();
    const profile = useContext(RegistrationStatus);
    // console.log(profile,'Context Profile Status on product page');
    const [filterError, setFilterError] = useState();
    const [filterMessage, setFilterMessage] = useState();

    //multiple product price model
    const [showMultiProduct, setShowMultiProduct] = useState(false);
    const [showMultiProductUpdate, setShowMultiProductUpdate] = useState(false);

    //add filter modal
    const [showAddFilter, setShowAddFilter] = useState(false);
    const [showFilterProductUpdate, setShowMFilterProductUpdate] = useState(false);

    //add filter List
    const [filterList, setFilterList] = useState([]);
    //model
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);

    //loader
    const [loader, setLoader] = useState(false)

    //shiprocket address check
    const [hasPickupAddress, setHasPickupAddress] = useState(true);
    const [pickupAddressList, setPickupAddressList] = useState([]);

    //tab key
    const [key, setKey] = useState('category');

    //show product list
    const [productShow, setProductShow] = useState();
    // console.log(productShow,'productShow');

    //product list btn change ststus
    const [selectedStatus, setSelectedStatus] = useState();

    //1st category data
    const [categoryData, setCategoryData] = useState('');

    //2nd category data
    const [subCategoryData, setSubCategoryData] = useState('');

    //3rdt category data
    const [lastCategoryData, setLastCategoryData] = useState('');

    //footer btn enable
    const [done, setDone] = useState(false);

    // Brand Array
    const [brandData, setBrandData] = useState('');

    //product size array
    const [productSize, setProductSize] = useState('');
    // console.log(productSize,'size');

    //product filter array
    const [productFilter, setProductFilter] = useState('');
    // console.log(productFilter,'productFilter');

    //product filter array
    const [productFilterValue, setProductFilterValue] = useState('');
    // console.log(productFilterValue,'productFilterValue');

    //select size option (many or one size,radio btn)
    const [sizeOption, setSizeOption] = useState('1');
    //  console.log(sizeOption,'sizeOption');

    //return policy check box list array
    const [policyList, SetPolicyList] = useState();
    const [cancelPolicyList, setCancelPolicyList] = useState([]);
    // console.log(policyList,'policyList data');

    //return day option (yes or No,radio btn )
    const [returnDay, setReturnDay] = useState('1');

    //product ID
    const [productID, setProductID] = useState('');
    // console.log(productID,'productID');

    const [sizeID, setSizeID] = useState('');

    //product price and size list show
    const [multiProductList, setMultiProductList] = useState([]);

    //pagination
    const [paginate, setPaginate] = useState();

    //product price commision 
    const [taxTable, setTaxTable] = useState(false);

    const [tax, setTax] = useState();

    const [adminCommission, setAdminCommission] = useState();

    const [dataTax, setDataTax] = useState();
    const [filePreview, setFilePreview] = useState();
    const [errors, setErrors] = useState();
    // console.log(dataTax,"dataTax");


    // Temporary Image
    const [file, setFile] = useState([]);
    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [filePreviews, setFilePreviews] = useState([]);
    const [sizeChartFile, setSizeChartFile] = useState(null);
    const [sizeChartPreview, setSizeChartPreview] = useState(null);

    // Image Add Function
    const handleChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const newFiles = Array.from(e.target.files);
            const updatedPhotos = [...selectedPhotos, ...newFiles];
            const newPreviews = newFiles.map(f => URL.createObjectURL(f));
            const updatedPreviews = [...filePreviews, ...newPreviews];

            setSelectedPhotos(updatedPhotos);
            setFilePreviews(updatedPreviews);
            setAddProductData(prev => ({
                ...prev,
                image: updatedPhotos[0],
                images: updatedPhotos
            }));
            setFilePreview(prev => ({
                ...prev,
                image: updatedPreviews[0],
                images: updatedPreviews
            }));
            if (errors && errors.image) {
                setErrors(prev => ({ ...prev, image: null }));
            }
        }
        setLoader(false);
    };

    const handleRemovePhoto = (indexToRemove) => {
        const updatedPhotos = selectedPhotos.filter((_, idx) => idx !== indexToRemove);
        const updatedPreviews = filePreviews.filter((_, idx) => idx !== indexToRemove);
        setSelectedPhotos(updatedPhotos);
        setFilePreviews(updatedPreviews);
        setAddProductData(prev => ({
            ...prev,
            image: updatedPhotos.length > 0 ? updatedPhotos[0] : '',
            images: updatedPhotos
        }));
        setFilePreview(prev => ({
            ...prev,
            image: updatedPreviews.length > 0 ? updatedPreviews[0] : '',
            images: updatedPreviews
        }));
    };

    //add product category and information
    const [addProductData, setAddProductData] = useState({
        category_id: '',
        sub_category_id: '',
        third_category_id: '',
        brand_id: '',
        product_name: '',
        short_description: '',
        long_description: '',
        weight: '',
        height: '',
        width: '',
        is_policy: '2',
        return_policy_id: '',
        return_day: '0',
        image: '',
        return_policy: NO_RETURN_POLICY_TEXT,
        is_cancel_policy: '2',
        cancel_policy_id: '',
        gst: '',
        pickup_address_id: '',
        is_brand: '1',
        specifications: '',
        key_features: '',
        manufacturer_info: '',
        packer_info: '',
        importer_info: '',
        country_of_origin: '',
    });
    console.log('Product Added', addProductData.main_image)

    const handleSizeChartChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setSizeChartFile(file);
            setSizeChartPreview(URL.createObjectURL(file));
        }
    };

    const removeSizeChart = () => {
        setSizeChartFile(null);
        setSizeChartPreview(null);
    };


    const AddProductData = async () => {
        // Validation for mandatory fields
        if (addProductData.is_brand === '1' && !addProductData.brand_id) {
            toast.error("Brand is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.product_name) {
            toast.error("Product name is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.short_description) {
            toast.error("Short description is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.long_description) {
            toast.error("Long description is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.key_features || !addProductData.key_features.trim()) {
            toast.error("Key Features / Product Features is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.specifications || !addProductData.specifications.trim()) {
            toast.error("Product Specifications is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.country_of_origin || !addProductData.country_of_origin.trim()) {
            toast.error("Country of Origin is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.manufacturer_info || !addProductData.manufacturer_info.trim()) {
            toast.error("Manufacturer Information is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.packer_info || !addProductData.packer_info.trim()) {
            toast.error("Packer Information is mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.weight || !addProductData.height || !addProductData.width || !addProductData.length) {
            toast.error("Product dimensions (weight, height, width, length) are mandatory.");
            setKey('information');
            return;
        }
        if (!addProductData.gst) {
            toast.error("GST is mandatory.");
            setKey('information');
            return;
        }
        const photoCount = selectedPhotos ? selectedPhotos.length : (addProductData.image ? 1 : 0);
        if (photoCount < 3) {
            const msg = `At least 3 product photos are required for product creation. You currently have ${photoCount} photo(s).`;
            alert(msg);
            toast.error(msg);
            setErrors(prev => ({ ...prev, image: "At least 3 product photos are required for product creation." }));
            setKey('information');
            return;
        }
        if (sizeOption === '1' && (!productPrice.mrp || !productPrice.price || !productPrice.stock)) {
            toast.error("Price, MRP, and Stock are mandatory.");
            setKey('price');
            return;
        }
        if (sizeOption === '2' && (!multiProductList || multiProductList.length === 0)) {
            toast.error("Please add at least one product size and price.");
            setKey('price');
            return;
        }

        setLoader(true);
        try {
            // make Form Data
            const formData = new FormData();
            formData.append("category_id", addProductData.category_id);
            formData.append("sub_category_id", addProductData.sub_category_id);
            formData.append("third_category_id", addProductData.third_category_id);
            if (addProductData.is_brand === '1') {
                formData.append("brand_id", addProductData.brand_id);
            }
            formData.append("is_brand", addProductData.is_brand);
            formData.append("product_name", addProductData.product_name);
            formData.append("short_description", addProductData.short_description);
            formData.append("long_description", addProductData.long_description);
            formData.append("weight", addProductData.weight);
            formData.append("height", addProductData.height);
            formData.append("width", addProductData.width);
            formData.append("length", addProductData.length);
            formData.append("gst", addProductData.gst);
            formData.append("is_policy", addProductData.is_policy);
            if (addProductData.is_policy == '1') {
                if (addProductData.return_policy_id) {
                    formData.append("return_policy_id", addProductData.return_policy_id);
                }
                formData.append("return_day", addProductData.return_day || '');
                formData.append("return_policy", addProductData.return_policy || '');
            } else {
                formData.append("return_day", '0');
                formData.append("return_policy", addProductData.return_policy || NO_RETURN_POLICY_TEXT);
            }
            if (selectedPhotos && selectedPhotos.length > 0) {
                formData.append("image", selectedPhotos[0]);
                selectedPhotos.forEach((photoFile, idx) => {
                    formData.append("images[]", photoFile);
                });
            } else if (addProductData.image) {
                formData.append("image", addProductData.image);
            }
            if (sizeChartFile) {
                formData.append("size_chart_image", sizeChartFile);
            }
            if (addProductData.is_cancel_policy === '1' && addProductData.cancel_policy_id) {
                formData.append("cancel_policy_id", addProductData.cancel_policy_id);
            }
            if (addProductData.pickup_address_id) {
                formData.append("pickup_address_id", addProductData.pickup_address_id);
            }
            if (addProductData.specifications) {
                formData.append("specifications", addProductData.specifications);
            }
            if (addProductData.key_features) {
                formData.append("key_features", addProductData.key_features);
            }
            if (addProductData.manufacturer_info) {
                formData.append("manufacturer_info", addProductData.manufacturer_info);
            }
            if (addProductData.packer_info) {
                formData.append("packer_info", addProductData.packer_info);
            }
            if (addProductData.importer_info) {
                formData.append("importer_info", addProductData.importer_info);
            }
            if (addProductData.country_of_origin) {
                formData.append("country_of_origin", addProductData.country_of_origin);
            }

            // Append sizes and price
            if (sizeOption === '1' && (productPrice.mrp || productPrice.price || productPrice.stock)) {
                formData.append('sizes[0][name]', 'Free Size');
                formData.append('sizes[0][mrp]', productPrice.mrp || 0);
                formData.append('sizes[0][price]', productPrice.price || 0);
                formData.append('sizes[0][stock]', productPrice.stock || 0);
                if (productPrice.sku) {
                    formData.append('sizes[0][sku]', productPrice.sku);
                }
            } else if (multiProductList && multiProductList.length > 0) {
                multiProductList.forEach((size, index) => {
                    formData.append(`sizes[${index}][name]`, size.name || '');
                    formData.append(`sizes[${index}][mrp]`, size.mrp || '');
                    formData.append(`sizes[${index}][price]`, size.price || '');
                    formData.append(`sizes[${index}][stock]`, size.stock || '');
                    if (size.sku) {
                        formData.append(`sizes[${index}][sku]`, size.sku);
                    }
                });
            }

            // Append filters
            if (filterList && filterList.length > 0) {
                filterList.forEach((filter, index) => {
                    formData.append(`filters[${index}][filter_name]`, filter.filter_name || filter.name || filter.main_category_name || '');
                    formData.append(`filters[${index}][filter_value]`, filter.filter_value || filter.value || filter.sub_category_name || '');
                    if (filter.images && filter.images.length > 0) {
                        filter.images.forEach((img) => {
                            formData.append(`filters[${index}][images][]`, img);
                        });
                    }
                });
            }

            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/product/add`, formData);
            console.log(response.data, 'addProductData response');
            if (response.data.success) {
                toast.success("Product added successfully!");
                setShow(false);
                setAddProductData({
                    category_id: '',
                    sub_category_id: '',
                    third_category_id: '',
                    brand_id: '',
                    is_brand: '1',
                    product_name: '',
                    short_description: '',
                    long_description: '',
                    weight: '',
                    height: '',
                    width: '',
                    length: '',
                    is_policy: '2',
                    return_policy_id: '',
                    return_day: '0',
                    image: '',
                    return_policy: NO_RETURN_POLICY_TEXT,
                    is_cancel_policy: '2',
                    cancel_policy_id: '',
                    gst: '',
                    pickup_address_id: ''
                });
                setMultiProductList([]);
                setFilterList([]);
                setKey('category');
                fetchProductList();
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
            const errs = error.response?.data?.errors;
            setErrors(errs || {});
            if (errs) {
                const firstKey = Object.keys(errs)[0];
                const firstMsg = Array.isArray(errs[firstKey]) ? errs[firstKey][0] : errs[firstKey];
                toast.error(firstMsg || "Please check the form for errors.");
                const infoFields = ['product_name', 'brand_id', 'weight', 'height', 'width', 'length', 'gst', 'short_description', 'pickup_address_id'];
                if (infoFields.some(key => errs[key])) {
                    setKey('information');
                }
            } else if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to add product. Please try again.");
            }
        }
    }

    const onchangeSizeOption = (sizeType) => {
        setSizeOption(sizeType)
        setProductPrice({
            ...productPrice,
            type: sizeType,
        })
    }

    //add product size and price
    const [productPrice, setProductPrice] = useState({
        product_id: '',
        stock: '',
        mrp: '',
        price: '',
        size: '',
        size_name: '',
        type: sizeOption,
        product_size_id: '',

    })
    // console.log('productPrice',productPrice);

    // Open Add price Modal
    const openAddPriceModal = () => {
        setProductPrice({
            product_size_id: '',
            stock: '',
            mrp: '',
            price: '',
            size: '',
            product_id: data.product_id,
            type: sizeOption,
        });
        setShowMultiProduct(true)
    }

    //product price and size list show
    const addproductPrice = async () => {
        setLoader(true);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/product/size/add`, productPrice);
            console.log(response.data, 'addProductPrice response');

            if (response.data.success) {
                // DisableHandler3();
                const data = response.data.data
                if (sizeOption && sizeOption == '1') {
                    DisableHandler3();
                } else if (sizeOption && sizeOption == '2') {
                    // let product = multiProductList;
                    // product.push(productPrice);
                    // await setMultiProductList(product);
                    await multiProductFetchList();
                    setShowMultiProduct(false);
                } else {
                    setLoader(false);
                }
                setLoader(false);
            }
            setLoader(false);
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    }

    const multiProductUpdateHandle = (item) => {
        // console.log(item,'item');
        setProductPrice({
            ...productPrice,
            product_size_id: item.id,
            stock: item.stock,
            mrp: item.mrp,
            price: item.price,
            size: item.size_id,
            product_id: data.product_id,
            type: sizeOption,
        });
        setShowMultiProductUpdate(true);
    }

    // update product size and price
    const UpdateproductMulti = async () => {
        setLoader(true);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/product/size/add`, productPrice);
            console.log(response.data, 'UpdateproductPrice response');
            if (response.data.success) {
                await multiProductFetchList();
                setShowMultiProductUpdate(false);
                setLoader(false);
            }

        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    }

    const [data, setData] = useState({
        product_id: productID
    });

    const multiProductFetchList = async () => {
        setLoader(true);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`seller/product/size/fetch`, data);
            console.log(response.data.data, 'multiProductFetchList respons');
            if (response.data.success) {
                setMultiProductList(response.data.data.list);
            }
            setLoader(false);
        } catch (error) {
            console.log(error, 'error');
            setLoader(false);
        }
    }

    // product fetch Api
    const fetchProductList = async (status) => {
        setLoader(true);
        const data = {
            status: status,
        }
        try {
            let token = decrpt(Cookies.get('s_l'));
            // let user = Cookies.get('username');
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/product/list`, data)
            if (response.data.data.list) {
                console.log('fetchProductList', response.data.data.list);
                setProductShow(response.data.data.list);
                setPaginate(response.data.data.pagination);
                if (profile.profile === '5' || profile.profile === '6') {
                    setLoader(false);
                }
            }
        } catch (error) {
            // console.log('Error',error.response);
            setLoader(false);
        }
    }

    //list btn status change
    const statusTypeHandler = (status) => {
        fetchProductList(status);
        setSelectedStatus(status);
        console.log(status, 'status');
    }

    //1st Category data fetch api
    const fetchCategory = async () => {
        setLoader(true);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.get(`/seller/category/list/dropdown`);
            if (response.data) {
                setCategoryData(response.data.data);
                //  console.log('category',response.data.data);
                setLoader(false);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };

    //2nd subCategory data fetch api
    const fetchSubCategory = async (category_id) => {
        setLoader(true);

        let data = {
            category_id: category_id,
        }
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/category/sub/category/list/dropdown`, data);
            if (response.data.success) {
                setSubCategoryData(response.data.data);
                // console.log('subcategory',response.data.data);
                setLoader(false);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }

    };

    //3rd lastCategory data fetch api
    const fetchLastCategory = async (category_id) => {
        setLoader(true);

        let data = {
            category_id: category_id,
        }
        // console.log(category_id,"data");
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/category/sub/category/list/dropdown`, data);
            if (response.data.success) {
                setLastCategoryData(response.data.data);
                // console.log('lastcategory',response.data.data);
                setLoader(false);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };

    const fetchBrandData = async (catParams, isMainCategory = false) => {
        setLoader(true);
        console.log('fetchBrandData CALLED WITH:', catParams, isMainCategory);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            let payload = {};
            if (typeof catParams === 'object' && catParams !== null) {
                payload = {
                    category_id: catParams.category_id !== undefined ? catParams.category_id : addProductData.category_id,
                    sub_category_id: catParams.sub_category_id !== undefined ? catParams.sub_category_id : addProductData.sub_category_id,
                    third_category_id: catParams.third_category_id !== undefined ? catParams.third_category_id : addProductData.third_category_id
                };
            } else {
                const targetCat = catParams || addProductData.third_category_id || addProductData.sub_category_id || addProductData.category_id;
                payload = {
                    category_id: addProductData.category_id,
                    sub_category_id: addProductData.sub_category_id,
                    third_category_id: targetCat || addProductData.third_category_id
                };
            }

            console.log('Sending API Request with payload:', payload);
            const response = await axios.post(`/seller/product/brand/size/filter/fetch`, payload);
            console.log('API /seller/product/brand/size/filter/fetch returned:', response.data);
            if (response.data.success) {
                const brandList = response.data.data.brand_list || [];
                console.log('Setting brandData to:', brandList);
                setBrandData(brandList);
                setAddProductData(prev => {
                    const brandExists = brandList.some(b => String(b.brand_id) === String(prev.brand_id));
                    return {
                        ...prev,
                        brand_id: brandExists ? prev.brand_id : ''
                    };
                });
                setProductSize(response.data.data.size_list || []);
                setProductFilter(response.data.data.filter_list || []);
                setLoader(false);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };

    //product return policy list(check box)
    const fetchPolicyList = async () => {
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.get(`/seller/return/policy/list`);

            if (response.data.success) {
                SetPolicyList(response.data.data);
            }
        } catch (error) {
            console.log("Failed fetching seller policy list, trying user dropdown fallback", error);
            try {
                const res = await axios.get(`/user/return/policy/dropdown`);
                if (res.data.success) {
                    SetPolicyList(res.data.data);
                }
            } catch (err) {
                console.log(err);
            }
        }
    }

    //product cancellation policy list dropdown
    const fetchCancelPolicyList = async () => {
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.get(`/seller/cancel/policy/list`);

            if (response.data.success) {
                setCancelPolicyList(response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    //add product model open
    const openAddModel = () => {
        if (!hasPickupAddress) {
            alert("Please add at least one Shipping / Pickup Address before adding a product.");
            navigate('/address-shiprocket');
            return;
        }
        setShow(true)
        setKey('category')
        resetInputvalue();
    }

    //reset all input model open
    const resetInputvalue = () => {
        setSelectedPhotos([]);
        setFilePreviews([]);
        setSubCategoryData('')
        setLastCategoryData('')
        setDone('')
        // setThirdCategoryId('')
        setBrandData('')
        setProductSize('')
        // setSizeOption('')
        setReturnDay('')
        setAddProductData({
            ...addProductData,
            category_id: '',
            sub_category_id: '',
            third_category_id: '',
            image: '',
            images: []
        });
        setFilePreview(null);
        setSizeChartFile(null);
        setSizeChartPreview(null);
    }

    //submit btn Disable enable
    const [isDisabled1, setDisableButtons1] = useState(true);
    const DisableHandler1 = (() => {
        if (!addProductData.category_id || addProductData.category_id === 'Select Category' || addProductData.category_id === '') {
            toast.error("Please select a Category before proceeding.");
            return;
        }

        // Ensure brand data is fetched before moving to the information tab
        // in case the category was already set and not manually changed
        fetchBrandData({
            category_id: addProductData.category_id,
            sub_category_id: addProductData.sub_category_id,
            third_category_id: addProductData.third_category_id
        });

        setDisableButtons1(false);
        setKey('information');
    })

    const [isDisabled2, setDisableButtons2] = useState(true);
    const DisableHandler2 = (() => {
        if (!addProductData.pickup_address_id) {
            toast.error("Please select a Pickup / Shipping Address before proceeding.");
            setErrors(prev => ({ ...prev, pickup_address_id: "Pickup / Shipping Address is required" }));
            return;
        }

        const photoCount = selectedPhotos ? selectedPhotos.length : (addProductData.image ? 1 : 0);
        if (photoCount < 3) {
            const msg = `At least 3 product photos are required for product creation. You currently have ${photoCount} photo(s).`;
            alert(msg);
            toast.error(msg);
            setErrors(prev => ({ ...prev, image: "At least 3 product photos are required for product creation." }));
            return;
        }

        setDisableButtons2(false);
        setKey('price');
    })

    const [isDisabled3, setDisableButtons3] = useState(true);
    const DisableHandler3 = (() => {
        setDisableButtons3(false);
        setKey('filter');
    })

    // back button information
    const backBtnHandle = (tabindex) => {
        setKey('category');
    }

    // back button price
    const backBtnHandleInfo = (tabindex) => {
        setKey('information');
    }

    // pagination
    const handlePageChange = async (pageNumber) => {
        setLoader(true);
        console.log(`active page is ${pageNumber}`);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/product/list?page=${pageNumber}`)
            console.log(response, 'pageNumber');
            if (response.data.success) {
                setProductShow(response.data.data.list);
                setLoader(false);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    }

    //product price commision 
    const commisionApi = async (third_category_id) => {
        setLoader(true);
        let data = {
            category_id: addProductData.third_category_id,
        }
        console.log(data, 'commisionApi third')
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/tax_commissions/fetch/details`, data);
            console.log(response, 'response');
            if (response.data.success) {
                setDataTax(response.data.data);
                // console.log('commisionApi',response.data.data);
                taxCal();
                adminCom()
                setLoader(false);
            } else {
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }

    };

    const openTaxTable = (e) => {
        console.log(e, 'e');
        if (e.length > 0) {
            setTaxTable(true);
        } else {
            setTaxTable(false);
        }
        discountCal(e);
        taxCal();
        adminCom();
    }

    const discountCal = (e) => {
        const discount1 = parseFloat((productPrice.mrp - e)) / parseFloat(productPrice.mrp);
        const discount = parseFloat(discount1 * 100);
        // console.log('Discount',discount);
        setProductPrice({ ...productPrice, discount: discount, price: e })
    }

    const taxCal = () => {
        // Api Call for tax
        const discounttax = parseFloat(dataTax && dataTax.tax / 100) * parseFloat(productPrice.price);
        setTax(discounttax.toFixed(2));
    }

    const adminCom = () => {
        // Api Call for tax
        const adminCommission = parseFloat(dataTax && dataTax.commission / 100) * parseFloat(productPrice.price);
        setAdminCommission(adminCommission.toFixed(2));
    }

    const handleFilter = (item) => {
        console.log(item, 'filter data');

        let tmparray = productFilter;
        let obj = tmparray.find((o, i) => {
            // console.log(o,'ooo');
            if (o.filter_master_id == item) {
                setProductFilterValue(o.values);
            }
        });
        setProductAddFilter({ ...productAddFilter, filter_master_id: item })
    }

    const handleFilterDetails = (item) => {
        setProductAddFilter({ ...productAddFilter, filter_master_id: item })
        setProductAddFilter({ ...productAddFilter, filter_master_details_id: item })
    }

    //add product filter
    const [productAddFilter, setProductAddFilter] = useState({
        product_filter_id: '',
        product_id: '',
        filter_master_id: '',
        filter_master_details_id: '',
    })
    // console.log(productAddFilter,'productFilterAdd');

    // Open Add Filter Modal
    const openFilterModal = () => {
        setProductAddFilter({
            product_filter_id: '',
            product_id: data.product_id,
            filter_master_id: '',
            filter_master_details_id: '',
        });
        setShowAddFilter(true)
    }
    console.log(productAddFilter && productAddFilter, 'productAddFilter ds')

    const addProductFilter = async () => {
        setLoader(true);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/product/filter/add`, productAddFilter);
            // console.log(response.data,'addProductFilter response');
            if (response.data.success) {
                setShowAddFilter(false);
                await filterFetchList();
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
            setFilterMessage(error.response.data.message)
        }
    }

    const filterProductUpdateHandle = async (item) => {
        console.log(item, 'productFilterItem');
        await setProductAddFilter({
            product_filter_id: item.id,
            product_id: data.product_id,
            filter_master_id: item.main_category_id,
            filter_master_details_id: item.sub_category_id,
        });
        setShowMFilterProductUpdate(true);
    }

    const UpdateproductFilter = async () => {
        setLoader(true);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await axios.post(`/seller/product/filter/add`, productAddFilter);
            console.log(response.data, 'UpdateproductPrice response');
            if (response.data.success) {
                setShowMFilterProductUpdate(false);
                await filterFetchList();
                setLoader(false);
            }
            setLoader(false);
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    }

    const filterFetchList = async () => {
        setLoader(true);
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const data = { product_id: productAddFilter?.product_id }
            const response = await axios.post(`seller/product/filter/fetch`, data);
            // console.log(response.data.data,'filterFetchList respons');
            if (response.data.success) {
                setFilterList(response.data.data.list);

            }
            setLoader(false);
        } catch (error) {
            console.log(error, 'error');
            setLoader(false);
        }
    }

    // const imageUploadProduct = async() => {
    //     try {
    //         const data = {
    //             product_id : '' ,
    //             image : ''
    //         }
    //         let token = decrpt(Cookies.get('s_l'));
    //         axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    //         const response = await axios.post(`seller/product/image/upload`,data);
    //     }catch{

    //     }
    // }

    // view details
    const viewDetails = (item) => {
        navigate('./single', { state: { item, mode: 'view' } });
    }

    const editDetails = (item) => {
        navigate('./single', { state: { item, mode: 'edit' } });
    }

    const deleteProduct = async (id) => {
        if (window.confirm('Are you sure you want to delete this product?')) {
            setLoader(true);
            try {
                let token = decrpt(Cookies.get('s_l'));
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const response = await axios.post(`/seller/product/delete`, { product_id: id });
                if (response.data.success) {
                    toast.success(response.data.message);
                    fetchProductList();
                } else {
                    toast.error('Failed to delete product');
                    setLoader(false);
                }
            } catch (error) {
                console.log(error);
                toast.error(error.response?.data?.message || 'Failed to delete product');
                setLoader(false);
            }
        }
    };

    //check if seller has pickup address
    const checkPickupAddress = async () => {
        try {
            let token = decrpt(Cookies.get('s_l'));
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const res = await axios.get('/seller/shiprocket/pickup-address/list');
            if (res.data?.status && Array.isArray(res.data.data)) {
                setPickupAddressList(res.data.data);
                if (res.data.data.length > 0) {
                    setHasPickupAddress(true);
                } else {
                    setHasPickupAddress(false);
                }
            }
        } catch (error) {
            console.log(error);
            setHasPickupAddress(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchCategory();
        fetchProductList();
        fetchPolicyList();
        fetchCancelPolicyList();
        checkPickupAddress();
        // filterFetchList();
        // commisionApi();
        // taxCal();
        // adminCom();

    }, []);

    return (
        <>
            <ToastContainer />
            {/* New Order */}
            {/* {loader ? <Loader />
            : */}
            <div className="responsive-xs responsive-sm">
                {profile && profile.profile == 5 ?
                    <NotApprove /> :
                    <>
                        <div style={{ display: show ? 'none' : 'block' }}>
                            {!hasPickupAddress && (
                                <div className="alert alert-warning d-flex align-items-center justify-content-between mb-3 shadow-sm" role="alert" style={{ borderRadius: '8px', borderLeft: '4px solid #ffc107', background: '#fff9e6', padding: '12px 16px' }}>
                                    <div>
                                        <strong>⚠️ Shipping Address Required: </strong>
                                        You have not added a shipping / pickup address yet. Please add a pickup address before adding products.
                                    </div>
                                    <button className="btn btn-sm btn-warning fw-bold px-3 text-dark" onClick={() => navigate('/address-shiprocket')}>
                                        Add Address Now
                                    </button>
                                </div>
                            )}
                            {/* Count */}
                            <div className="count-section d-flex justify-content-between">
                                {/* count 1 */}
                                <button className="product-page-block d-flex align-items-center" onClick={() => statusTypeHandler(3)} style={selectedStatus == 3 ? styles.activeBtn : null}>
                                    <div className="product-page-inner-block">
                                        <h5 style={selectedStatus == 3 ? styles.activeBtnTxt : null}><AiOutlinePullRequest /> Requested</h5>
                                    </div>
                                </button>
                                {/* count 2 */}
                                <button className="product-page-block d-flex align-items-center" onClick={() => statusTypeHandler(1)} style={selectedStatus == 1 ? styles.activeBtn : null}>
                                    <div className="product-page-inner-block">
                                        <h5 style={selectedStatus == 1 ? styles.activeBtnTxt : null}><AiOutlineCheckCircle /> Approved</h5>
                                    </div>
                                </button>
                                {/* count 3 */}
                                <button className="product-page-block d-flex align-items-center" onClick={() => statusTypeHandler(4)} style={selectedStatus == 4 ? styles.activeBtn : null}>
                                    <div className="product-page-inner-block">
                                        <h5 style={selectedStatus == 4 ? styles.activeBtnTxt : null}><AiOutlineCloseCircle /> Rejected</h5>
                                    </div>
                                </button>
                                <button className="product-page-block d-flex align-items-center " onClick={() => openAddModel()}>
                                    <div className="product-page-inner-block">
                                        <h5 ><AiOutlinePlusCircle /> Add Product</h5>
                                    </div>
                                </button>
                            </div>
                            <>
                                <div className="section">
                                    <div className="row align-items-center">
                                        <div className="col-md-12">
                                            <div className="card p-2">
                                                <div className="card-title d-flex align-items-center justify-content-between">
                                                    <div>
                                                        <h5>New Order</h5>
                                                    </div>
                                                    {/* <div>
                                                        <Link to='./productSearch' className="btn btn-sm btn-warning" >Search</Link>
                                                        </div> */}
                                                </div>
                                                <Table responsive="sm">
                                                    <thead>
                                                        <tr className="text-center">
                                                            <th>Product ID</th>
                                                            <th>Product Name</th>
                                                            <th>Category</th>
                                                            <th>Pickup Location</th>
                                                            <th>Sub category</th>
                                                            <th>Brand</th>
                                                            <th>Order Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ verticalAlign: 'middle' }} className="text-left">
                                                        {productShow && productShow.length > 0 ?
                                                            <>
                                                                {productShow && productShow.map((item, index) => {
                                                                    return (
                                                                        <tr key={index} >
                                                                            <td>P0{item.id} </td>
                                                                            <td><img src={item.main_image} className="product-table-img" />{item.name}</td>
                                                                            <td>{item.category}</td>
                                                                            <td>
                                                                                {item.pickup_location || item.pickup_address_name ? (
                                                                                    <span className="badge bg-light text-dark border">
                                                                                        <i className="bi bi-geo-alt-fill text-danger me-1"></i>
                                                                                        {item.pickup_location || item.pickup_address_name}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="text-muted" style={{ fontSize: '13px' }}>Not set</span>
                                                                                )}
                                                                            </td>
                                                                            <td>{item.sub_category}</td>
                                                                            <td>{item.brand}</td>
                                                                            <td>
                                                                                <OrderStatus delivery_status={item.status} />
                                                                            </td>
                                                                            <td>
                                                                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                                                                    <button type="button" className='btn btn-xs btn-success text-white table-btn' onClick={() => viewDetails(item.id)}>View</button>
                                                                                    <button type="button" className='btn btn-xs btn-primary text-white table-btn' onClick={() => editDetails(item.id)} title="Edit"><BiEditAlt /></button>
                                                                                    <button type="button" className='btn btn-xs btn-danger text-white table-btn' onClick={() => deleteProduct(item.id)} title="Delete"><BiTrash /></button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}</>
                                                            :
                                                            <tr>
                                                                <td colSpan={5}>No Product Found</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </Table>
                                                {productShow && productShow.length > 0 ?
                                                    <>
                                                        <div className="col-md-12">
                                                            <Pagination
                                                                totalItemsCount={paginate && paginate.total_data}
                                                                onChange={handlePageChange}
                                                                activePage={paginate && paginate.current_page}
                                                                itemsCountPerPage={paginate && paginate.per_page}
                                                                pageRangeDisplayed={10}
                                                            />
                                                        </div>
                                                    </> : <></>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                        {show && (
                            <div className="add-product-screen bg-white p-4 rounded shadow-sm mt-3">
                                <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                                    <h3 className="mb-0">Add New Product</h3>
                                    <button className="btn btn-outline-secondary fw-bold" onClick={() => setShow(false)}>
                                        Back to Product List
                                    </button>
                                </div>
                                {loader && <Loader />}
                                <div className="tab-block-main p-3" style={{ backgroundColor: '#f4f6f9', borderRadius: '8px' }}>
                                    <Tabs
                                        activeKey={key}
                                        onSelect={(k) => setKey(k)}
                                        id="noanim-tab-example"
                                        className="mb-3 justify-content-around tab-block product-add">
                                        <Tab eventKey="category" title="1. Category" className="flex-grow-1">
                                            <div className="bg-white p-3 rounded shadow-sm mb-3">
                                                <AddCategory categoryData={categoryData}
                                                    subCategoryData={subCategoryData}
                                                    fetchSubCategory={fetchSubCategory}
                                                    fetchLastCategory={fetchLastCategory}
                                                    lastCategoryData={lastCategoryData}
                                                    done={done} setDone={setDone}
                                                    fetchBrandData={fetchBrandData}
                                                    DisableHandler1={DisableHandler1}
                                                    addProductData={addProductData}
                                                    setAddProductData={setAddProductData}
                                                />
                                                <div className="d-flex justify-content-end mt-3 border-top pt-3">
                                                    <button className="btn btn-primary px-4" onClick={DisableHandler1}>Next</button>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab eventKey="information" title="2. Information" className="flex-grow-1" disabled={isDisabled1}>
                                            <div className="bg-white p-3 rounded shadow-sm mb-3">
                                                <ProductInformation
                                                    brandData={brandData}
                                                    fetchBrandData={fetchBrandData}
                                                    // thirdCategoryId={thirdCategoryId}
                                                    returnDay={returnDay}
                                                    setReturnDay={setReturnDay}
                                                    sizeOption={sizeOption}
                                                    // setSizeOption={setSizeOption}
                                                    onchangeSizeOption={onchangeSizeOption}
                                                    policyList={policyList}
                                                    cancelPolicyList={cancelPolicyList}
                                                    DisableHandler2={DisableHandler2}
                                                    backBtnHandle={backBtnHandle}
                                                    addProductData={addProductData}
                                                    setAddProductData={setAddProductData}
                                                    AddProductData={AddProductData}
                                                    productID={productID}
                                                    sizeID={sizeID}
                                                    handleChange={handleChange}
                                                    file={file}
                                                    setFile={setFile}
                                                    selectedPhotos={selectedPhotos}
                                                    filePreviews={filePreviews}
                                                    handleRemovePhoto={handleRemovePhoto}
                                                    errors={errors}
                                                    setErrors={setErrors}
                                                    filePreview={filePreview}
                                                    setFilePreview={setFilePreview}
                                                    pickupAddressList={pickupAddressList}
                                                    navigate={navigate}
                                                    handleSizeChartChange={handleSizeChartChange}
                                                    removeSizeChart={removeSizeChart}
                                                    sizeChartPreview={sizeChartPreview}
                                                />
                                                <div className="d-flex justify-content-between mt-3 border-top pt-3">
                                                    <button className="btn btn-secondary px-4" onClick={backBtnHandle}>Back</button>
                                                    <button className="btn btn-primary px-4" onClick={DisableHandler2}>Next</button>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab eventKey="price" title="3. Price & Stock" className="flex-grow-1" disabled={isDisabled2}>
                                            <div className="bg-white p-3 rounded shadow-sm mb-3">
                                                <ProductPrice
                                                    setProductSize={setProductSize}
                                                    productSize={productSize}
                                                    sizeOption={sizeOption}
                                                    DisableHandler3={DisableHandler3}
                                                    backBtnHandleInfo={backBtnHandleInfo}
                                                    productID={productID}
                                                    sizeID={sizeID}
                                                    productPrice={productPrice}
                                                    setProductPrice={setProductPrice}
                                                    addproductPrice={addproductPrice}
                                                    taxTable={taxTable}
                                                    setTaxTable={setTaxTable}
                                                    tax={tax}
                                                    setTax={setTax}
                                                    adminCommission={adminCommission}
                                                    setAdminCommission={setAdminCommission}
                                                    openTaxTable={openTaxTable}
                                                    discountCal={discountCal}
                                                    taxCal={taxCal}
                                                    adminCom={adminCom}
                                                    commisionApi={commisionApi}
                                                    addProductData={addProductData}
                                                    setAddProductData={setAddProductData}
                                                    showMultiProduct={showMultiProduct}
                                                    setShowMultiProduct={setShowMultiProduct}
                                                    // multiProductFetchList={multiProductFetchList}
                                                    multiProductList={multiProductList}
                                                    setMultiProductList={setMultiProductList}
                                                    UpdateproductMulti={UpdateproductMulti}
                                                    showMultiProductUpdate={showMultiProductUpdate}
                                                    setShowMultiProductUpdate={setShowMultiProductUpdate}
                                                    multiProductUpdateHandle={multiProductUpdateHandle}
                                                    openAddPriceModal={openAddPriceModal}
                                                />
                                                <div className="d-flex justify-content-between mt-3 border-top pt-3">
                                                    <button className="btn btn-secondary px-4" onClick={backBtnHandleInfo}>Back</button>
                                                    <button className="btn btn-primary px-4" onClick={DisableHandler3}>Next</button>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab eventKey="filter" title="4. Filters / Colors" className="flex-grow-1" disabled={isDisabled3}>
                                            <div className="bg-white p-3 rounded shadow-sm mb-3">
                                                <Filter
                                                    productFilter={productFilter}
                                                    setProductFilter={setProductFilter}
                                                    handleFilter={handleFilter}
                                                    productFilterValue={productFilterValue}
                                                    showAddFilter={showAddFilter}
                                                    setShowAddFilter={setShowAddFilter}
                                                    addProductFilter={addProductFilter}
                                                    productAddFilter={productAddFilter}
                                                    setProductAddFilter={setProductAddFilter}
                                                    handleFilterDetails={handleFilterDetails}
                                                    filterList={filterList}
                                                    setFilterList={setFilterList}
                                                    filterProductUpdateHandle={filterProductUpdateHandle}
                                                    showFilterProductUpdate={showFilterProductUpdate}
                                                    setShowMFilterProductUpdate={setShowMFilterProductUpdate}
                                                    UpdateproductFilter={UpdateproductFilter}
                                                    openFilterModal={openFilterModal}
                                                    setShow={setShow}
                                                    filterMessage={filterMessage}
                                                />
                                                
                                                {/* Product Review Summary Box */}
                                                <div className="card mt-4 mb-3 border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px', borderLeft: '4px solid #0d6efd' }}>
                                                    <div className="card-body p-3">
                                                        <h6 className="fw-bold mb-3 text-primary d-flex align-items-center" style={{ fontSize: '15px' }}>
                                                            📋 Product Summary Review
                                                        </h6>
                                                        <div className="row g-2 text-secondary" style={{ fontSize: '13.5px' }}>
                                                            <div className="col-md-4">
                                                                <strong className="text-dark">Product Name:</strong> {addProductData.product_name || <span className="text-muted">Not specified</span>}
                                                            </div>
                                                            <div className="col-md-4">
                                                                <strong className="text-dark">GST Rate:</strong> {addProductData.gst ? `${addProductData.gst}%` : <span className="text-muted">Not selected</span>}
                                                            </div>
                                                            <div className="col-md-4">
                                                                <strong className="text-dark">Pickup Location:</strong> {pickupAddressList.find(a => a.id == addProductData.pickup_address_id)?.name || <span className="text-muted">Selected</span>}
                                                            </div>
                                                            <div className="col-md-4">
                                                                <strong className="text-dark">Size Type:</strong> {sizeOption === '2' ? <span className="badge bg-info text-dark">Multi-Size Variants ({multiProductList?.length || 0})</span> : <span className="badge bg-secondary">Single Size</span>}
                                                            </div>
                                                            {sizeOption === '1' ? (
                                                                <div className="col-md-8">
                                                                    <strong className="text-dark">Pricing & Stock:</strong> ₹{productPrice.price || 0} (MRP: ₹{productPrice.mrp || 0}) | Stock: {productPrice.stock || 0} {productPrice.sku ? `| SKU: ${productPrice.sku}` : ''}
                                                                </div>
                                                            ) : (
                                                                <div className="col-md-8">
                                                                    <strong className="text-dark">Variants List:</strong> {multiProductList?.map(s => `${s.name} (₹${s.price}, Stock:${s.stock}${s.sku ? `, SKU:${s.sku}` : ''})`).join(' • ') || 'No variants added'}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between mt-3 border-top pt-3">
                                                    <button className="btn btn-secondary px-4" onClick={() => setKey('price')}>Back</button>
                                                    <button className="btn btn-success fw-bold px-4" onClick={() => AddProductData()}>
                                                        <i className="bi bi-check-circle-fill me-2"></i> Submit Product
                                                    </button>
                                                </div>
                                            </div>
                                        </Tab>
                                    </Tabs>
                                </div>
                            </div>
                        )}
                        <Outlet />
                    </>
                }
            </div>
            {/* } */}
        </>
    );
}

export default ProductList;
const styles = {
    activeTable: { disply: 'table-row' },
    inActiveTable: { display: 'none' },
    activeBtn: { backgroundColor: '#ffc001ad' },
    activeBtnTxt: { color: '#000' },
}; 